<template>
  <nav class="col-12 navbar nav-header py-0">
    <div class="w-100 d-flex w-100 d-flex align-items-center position-relative align-items-center position-relative"
      :class="headerClassList">
      <!-- <dropdown-basic
        class="businesses-dropdown"
        :text="business.tradeName"
        :left="true"
        v-if="business"
      >
        <template #dropdown-content>
          <b-dropdown-item
            class="dropdown-title"
            @click="$router.push({ name: 'businesses' })"
            >Ver todas las marcas</b-dropdown-item
          >

          <b-dropdown-item
            v-for="i in businesses"
            :key="i.id"
            @click="changeBusiness(i)"
            v-show="i.id !== business.id"
            >{{ i.tradeName }}
          </b-dropdown-item>
        </template>
</dropdown-basic> -->

      <!-- Mobile -->
      <div class="d-flex align-items-center d-lg-none">
        <img src="@/core/assets/images/layout/logo-admin.png" alt="ZET" class="sidebar-logo mr-2" />
        <span class="sidebar-title text-white w-50">ZET</span>
      </div>

      <div class="d-lg-none">
        <button type="button" class="bg-transparent px-0 border-0" @click="toggleMenu(true)">
          <MenuIcon />
        </button>
      </div>

      <!-- Desktop -->
      <BusinessesDropdown class="d-none d-lg-inline-block" v-if="!showViewAdmin && businesses.length > 1" />

      <!-- Desktop -->
      <router-link
        to="/businesses"
        class="d-none page-hader-button text-white text-decoration-none align-items-md-center d-lg-flex justify-content-md-center"
        v-if="(isSuperAdmin || isAdmin) && showViewAdmin"
        >
        <span class="text-center d-none d-md-inline-block"
          >Ver todas las marcas</span
        ></router-link
      >

      <UserDropdown class="d-none d-lg-block" :user="user" @logout="logout()" />
    </div>
  </nav>
</template>
<script>
import { mapGetters, mapMutations } from "vuex";
import { UserDropdown, MenuIcon } from "wize-admin";

import BusinessesDropdown from "./layout/BusinessesDropdown.vue"

export default {
  name: "PageHeader",
  data() {
    return {
      showCart: false,
      categories: [],
      subcategories: []
    };
  },
  components: {
    UserDropdown,
    BusinessesDropdown,
    MenuIcon
  },
  computed: {
    ...mapGetters({
      user: "auth/getUser",
      business: "app/getBusiness",
      businesses: "app/getBusinesses",
      currentDevice: "app/getCurrentDevice",
      isSuperAdmin: "auth/isSuperAdmin",
      isAdmin: "auth/isAdmin"
    }),
    showViewAdmin() {
      return this.$route.path.includes("admin")
    },
    headerClassList() {
      let val = 'justify-content-between'

      if(this.businesses.length <= 1) {
        val = 'justify-content-end'
      }

      return val
    }
  },
  methods: {
    ...mapMutations({
      toggleMenu: "app/toggleMenu",
    }),
    async changeBusiness(business) {
      this.$store.commit("app/business", business);

      if (this.$route.name !== "dashboard")
        this.$router.push({ name: "dashboard" });
    },
    async logout() {
      await this.$store.dispatch('auth/logout');
      this.$router.push({ name: "login" });
    }
  },
  mounted: function () { },
};
</script>

<style scoped lang="stylus">
</style>
